import { render, staticRenderFns } from "./ThreadListing.vue?vue&type=template&id=3ed5b2bb&"
import script from "./ThreadListing.vue?vue&type=script&lang=js&"
export * from "./ThreadListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports